import React, {useEffect, useState} from 'react'
import Ajax from '../../../../helpers/Ajax'
import TableLoader from '../../../UI/Dashboard/TableLoader';
import DataView from '../../../UI/Dashboard/DataView';
import TableContainer from '../../../UI/Dashboard/TableContainer';
import { Helmet } from 'react-helmet-async';
import ContentLayout from '../../../Common/ContentLayout'
import EditButton from '../../../UI/Dashboard/EditButton';
import DeleteButton from '../../../UI/Dashboard/DeleteButton';

export default function AmenityList() {
    const [dataList, setDataList] = useState(null)
    useEffect(()=>{
    const getResponse = setTimeout(function(){  
        (async()=>{ 
        const response = await Ajax({
            url: `/testimonial?limit=false`,
            token: true,
        })
        if(response.data.status === "SUCCESS!"){
           
            setDataList(response.data.result)
           
        }
       
        })()
    },100) 
    return()=>{
        clearInterval(getResponse)
    }
    },[])

    return (
    <ContentLayout title='Testimonials' addNew='/admin/add-testimonials'>
        <div className="row">
        <Helmet>
            <title>Testimonials</title>
        </Helmet>
        <DataView title="Testimonials">
            <TableContainer>
                <thead>
                    <tr>
                        <td className="text-center">S.No</td>
                        <td className="text-start">Name</td>
                        <td className="text-start">Designation</td>
                        <td className="text-start">Testimonial</td>
                        <td className="text-start">Image</td>
                        <td className="text-start">Type</td>
                        <td className="text-center">Active</td>
                        <td className="text-center">Edit</td>
                     
                    </tr>
                </thead>
                <tbody>
                    {dataList == null ? 
                    <TableLoader cols={8}/> : dataList.length === 0 ? 
                    <tr>
                        <td colSpan={8} className="text-center">Data not available</td>
                    </tr> : dataList.map((data, index)=>(
                    <tr key={data._id} >
                        <td className="text-center">{index + 1}</td>
                        <td className="text-start text-capitalize">{data.name?data.name:''}</td>
                        <td className="text-center">{data.designation?data.designation:''}</td>
                        <td className="text-start">{data.description?data.description:''}</td>
                        <td className="text-start"><img src={data.files?data.files.path:''} alt="icon" /></td>
                        <td className="text-start ">{data.type?data.type:''}</td>
                        <td className="text-center">{data.active === true ? <span className="badge bg-success">Enable</span> : <span className="badge bg-danger">Disable</span>}</td>
                        <td className="text-center">
                            <EditButton>{`/admin/testimonials/${data._id}`}</EditButton>
                        </td>
                       
                    </tr>
                    ))}
                </tbody>
            </TableContainer>
        </DataView>
    </div>
    </ContentLayout>
    )
}
